var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"loading":_vm.loadingItems,"label":_vm.$attrs.label || _vm.$t('nutriyou.bookingType'),"items":_vm.bookingTypes,"item-text":"Name","item-value":"BookingTypeId"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }